export { default as ConnectedInductees } from './ConnectedInductees';
